import { APIPolicyConfiguration, MessageLoggingPolicyConfiguration } from '../../../../remote-api/models'
import { RuntimeMajor } from './LogPointsRuntimeHelper'

type Expression =
    | { type: 'simple', prefix: string, message: string }
    | { type: 'pure', expression: string }

type Expressions = {
    [key: string]: Expression
}

export const muleFourDataWeaveExpressions: Expressions = {
    ['anypoint-monitoring-log-points-request-user-agent']: {
        type: 'simple',
        prefix: `'Anypoint Monitoring - Log Points - Request - User Agent: '`,
        message: `(attributes.headers['user-agent'] default 'null')`
    },
    ['anypoint-monitoring-log-points-request-path']: {
        type: 'simple',
        prefix: `'Anypoint Monitoring - Log Points - Request - Path: '`,
        message: `(attributes.requestPath default 'null')`
    },
    ['anypoint-monitoring-log-points-request-host']: {
        type: 'simple',
        prefix: `'Anypoint Monitoring - Log Points - Request - Host: '`,
        message: `(attributes.headers['host'] default 'null')`
    },
    ['anypoint-monitoring-log-points-request-method']: {
        type: 'simple',
        prefix: `'Anypoint Monitoring - Log Points - Request - Method: '`,
        message: `(attributes.method default 'null')`
    },
    ['anypoint-monitoring-log-points-request-remote-address']: {
        type: 'simple',
        prefix: `'Anypoint Monitoring - Log Points - Request - Remote Address: '`,
        message: `(attributes.remoteAddress default 'null')`
    },
    ['anypoint-monitoring-log-points-request-accept']: {
        type: 'simple',
        prefix: `'Anypoint Monitoring - Log Points - Request - Accept: '`,
        message: `(attributes.headers['accept'] default 'null')`
    },
    ['anypoint-monitoring-log-points-request-accept-encoding']: {
        type: 'simple',
        prefix: `'Anypoint Monitoring - Log Points - Request - Accept Encoding: '`,
        message: `(attributes.headers['accept-encoding'] default 'null')`
    },
    ['anypoint-monitoring-log-points-request-accept-language']: {
        type: 'simple',
        prefix: `'Anypoint Monitoring - Log Points - Request - Accept Language: '`,
        message: `(attributes.headers['accept-language'] default 'null')`
    },
    ['anypoint-monitoring-log-points-request-cookie']: {
        type: 'simple',
        prefix: `'Anypoint Monitoring - Log Points - Request - Cookie: '`,
        message: `(attributes.headers['cookie'] default 'null')`
    },
    ['anypoint-monitoring-log-points-request-referer']: {
        type: 'simple',
        prefix: `'Anypoint Monitoring - Log Points - Request - Referer: '`,
        message: `(attributes.headers['referer'] default 'null')`
    },
    ['anypoint-monitoring-log-points-request-body']: {
        type: 'pure',
        // tslint:disable-next-line:max-line-length
        expression: `#['Anypoint Monitoring - Log Points - Request - Body: ' ++ (if (!isEmpty(payload.^raw)) write(payload, "application/json") else 'empty payload')]`
    },
    ['anypoint-monitoring-log-points-response-status-code']: {
        type: 'simple',
        prefix: `'Anypoint Monitoring - Log Points - Response - Status Code: '`,
        message: `(attributes.statusCode default 'null')`
    },
    ['anypoint-monitoring-log-points-response-connection']: {
        type: 'simple',
        prefix: `'Anypoint Monitoring - Log Points - Response - Connection: '`,
        message: `(attributes.headers['connection'] default 'null')`
    },
    ['anypoint-monitoring-log-points-response-date']: {
        type: 'simple',
        prefix: `'Anypoint Monitoring - Log Points - Response - Date: '`,
        message: `(attributes.headers['date'] default 'null')`
    },
    ['anypoint-monitoring-log-points-response-set-cookie']: {
        type: 'simple',
        prefix: `'Anypoint Monitoring - Log Points - Response - Set-Cookie: '`,
        message: `(attributes.headers['set-cookie'] default 'null')`
    },
    ['anypoint-monitoring-log-points-response-pragma']: {
        type: 'simple',
        prefix: `'Anypoint Monitoring - Log Points - Response - Pragma: '`,
        message: `(attributes.headers['pragma'] default 'null')`
    },
    ['anypoint-monitoring-log-points-response-body']: {
        type: 'pure',
        // tslint:disable-next-line:max-line-length
        expression: `#['Anypoint Monitoring - Log Points - Response - Body: ' ++ (if (!isEmpty(payload.^raw)) write(payload, "application/json") else 'empty payload')]`
    }
}

export const flexGatewayDataWeaveExpressions: Expressions = {
    ...muleFourDataWeaveExpressions,
    ['anypoint-monitoring-log-points-request-body']: {
        type: 'pure',
        expression: `#['Anypoint Monitoring - Log Points - Request - Body: ' ++ (if (sizeOf(payload) > 0) payload else 'empty payload')]`
    },
    ['anypoint-monitoring-log-points-response-body']: {
        type: 'pure',
        expression: `#['Anypoint Monitoring - Log Points - Response - Body: ' ++ (if (sizeOf(payload) > 0) payload else 'empty payload')]`
    }
}

const copyConfigExpression = (configuration: MessageLoggingPolicyConfiguration, expression: string) => {
    return {...configuration, itemData: {...configuration.itemData, message: expression}}
}

export const addDataWeaveExpressions = (configuration: APIPolicyConfiguration, runtimeMajor: RuntimeMajor): APIPolicyConfiguration => {
    return (configuration as MessageLoggingPolicyConfiguration[]).map(configuration => {
        const category = configuration.itemData.category

        if (category) {
            const expressions = runtimeMajor === RuntimeMajor.MULE_ONE ? flexGatewayDataWeaveExpressions : muleFourDataWeaveExpressions
            const rawMessage = expressions[category]

            if (rawMessage) {
                switch (rawMessage.type) {
                    case 'pure':
                        const expression = rawMessage.expression
                        return copyConfigExpression(configuration, expression)

                    default:
                        const prefix = rawMessage.prefix
                        const message = rawMessage.message
                        const builtExpression = `#[${prefix} ++ ${message}]`
                        return copyConfigExpression(configuration, builtExpression)
                }
            }
        }

        return configuration
    })
}
